import React from 'react';

import './Inputs.scss';

export default class TextInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: null
        }
    }

    render() {
        let invalidClass = this.props.isInvalid ? 'invalid' : '';

        return (
            <input
                className={`a-input ${invalidClass} ${this.props.styleClass}`}
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                name={this.props.name}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Form/Inputs/TextInput.jsx